// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__cSkhY","paramInput":"JobSimulator_paramInput__2epB7","input":"JobSimulator_input__1TWP6"};